const translations = {
  'dates&fees.seo.title': 'Fechas del curso TEFL en Barcelona y Sevilla',
  'dates&fees.seo.description': `Obtén más información sobre las fechas y tarifas de los cursos de TEFL Iberia en Barcelona y Sevilla, y solicita convertirte en estudiante en línea.`,
  'dates&fees.sec1.title': 'Fechas y Tarifas',
  'dates&fees.sec2.title': 'Precios de cursos TEFL 2025',
  'dates&fees.sec2.optionalExtras': 'EXTRAS OPCIONALES ',
  'dates&fees.sec2.price': 'PRECIO',
  'dates&fees.sec2.accInBarcelona': '4 semanas de alojamiento en Barcelona',
  'dates&fees.sec2.accInSevillie': '4 semanas de alojamiento en Sevilla	',
  'dates&fees.sec2.airportPickUp': 'Recogida en el aeropuerto	',
  'dates&fees.sec2.culturalActivity': 'Actividad cultural	',
  'dates&fees.sec2.nie': 'Cita y asistencia para obtener el NIE	',
  'dates&fees.sec2.service': 'Servicio de empadronamiento',
  'dates&fees.sec2.teachingYL': 'Curso opcional de extensión para la enseñanza de niños',
  'dates&fees.sec3.title': 'Pago del Curso',
  'dates&fees.sec3.benefit1': 'Pago inicial de 450€ para asegurar tu plaza en el curso. ',
  'dates&fees.sec3.benefit2':
    'Los precios con descuento aplican cuando pagas el curso en su totalidad al momento de inscribirte. ',
  'dates&fees.sec3.benefit3':
    'Lee más acerca de nuestro<accentedLink> plan de pagos flexibles. </accentedLink>',
  'dates&fees.sec3.description':
    ' Puedes pagar tu curso con tarjeta de crédito/débito, efectivo, Transferwise o transferencia bancaria directa. Una vez que hayas aplicado y sido aceptado en el curso, se te proporcionará un enlace para completar el pago. Por favor, <accentedLink > ee nuestra política de reembolso.</accentedLink>',
  'dates&fees.cs.title': 'Fechas del curso',
  'dates&fees.cs.barcelona': 'Barcelona',
  'dates&fees.cs.sevillie': 'Sevilla',
};

export default translations;
